import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

import ApiVersionConstants from "../constants/api-version-constants";
import { CompanyListItem } from "./../models/CompanyListItem";

@Injectable({
  providedIn: "root",
})
export class ApprovedPriceService {
  private baseUrl = `${environment.apiConfig.uri}/${ApiVersionConstants.V_2}/admin/serviceMaxPrice`;

  constructor(private http: HttpClient) {}

  getItems(famCode: string): Observable<CompanyListItem[]> {
    return this.http.get<CompanyListItem[]>(this.baseUrl + "?famCode=" + famCode);
  }

  update(item: CompanyListItem): Observable<string> {
    return this.http.put<string>(this.baseUrl, item);
  }

  delete(item: CompanyListItem): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + "/delete", item);
  }

  addMaxPrice(item: CompanyListItem): Observable<string> {
    return this.http.post<string>(this.baseUrl, item);
  }
}
